import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileDown } from "lucide-react";
import { api } from "@/lib/api";
import { SelectField } from "@/lib/crm";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader, Panel, StatusBadge } from "@/components/common/ui-kit";
import { CAUSALI, DDT_ST, openDdtPdf } from "@/components/orders/OrderDdtPanel";

export default function DdtPage() {
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get("/ddt", { params: status ? { status } : {} }).then((r) => setItems(r.data.items)).catch(() => setItems([])), [status]);
  useEffect(() => { load(); }, [load]);
  const rows = (items || []).filter((d) => !q || `${d.number} ${d.order_number} ${d.company_name}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="ddt-page">
      <PageHeader overline="Vendite" title="DDT" description="Documenti di trasporto emessi dagli ordini cliente. Si creano dalla scheda ordine; quelli fatturabili compaiono in «Da fatturare» e si possono unire in una fattura." />
      <Panel className="p-4 md:p-5">
        <div className="mb-4 flex flex-wrap gap-3">
          <Input className="min-w-[200px] flex-1" placeholder="Cerca numero, ordine o cliente" value={q} onChange={(e) => setQ(e.target.value)} data-testid="ddt-search" />
          <SelectField value={status} onChange={setStatus} options={Object.entries(DDT_ST).map(([k, v]) => ({ key: k, label: v[0] }))} allowNone="Tutti gli stati" className="w-48" testId="ddt-filter-status" />
        </div>
        {items && !rows.length && <p className="py-10 text-center text-sm text-slate-500" data-testid="ddt-empty">Nessun DDT.</p>}
        <ul className="divide-y divide-line">{rows.map((d) => <li key={d.id} className="flex flex-wrap items-center gap-3 py-3" data-testid={`ddt-row-${d.id}`}>
          <StatusBadge tone={DDT_ST[d.status][1]}>{DDT_ST[d.status][0]}</StatusBadge>
          <div className="min-w-0 flex-1"><p className="font-mono text-xs font-semibold text-slate-500">{d.number} · {fmtDate(d.date)}</p>
            <p className="text-sm font-semibold text-ink"><Link to={`/clienti/${d.company_id}`} className="hover:text-brand-600">{d.company_name}</Link></p>
            <p className="text-xs text-slate-500"><Link to={`/ordini/${d.order_id}`} className="hover:text-brand-600">Ordine {d.order_number}</Link> · {CAUSALI.find((c) => c.key === d.causale)?.label} · {d.lines.length} {d.lines.length === 1 ? "riga" : "righe"}{d.invoice_number ? ` · fattura ${d.invoice_number}` : ""}</p></div>
          <Button size="sm" variant="outline" className="gap-1" onClick={() => openDdtPdf(d.id)} data-testid={`ddt-row-pdf-${d.id}`}><FileDown className="h-4 w-4" />PDF</Button></li>)}</ul>
      </Panel>
    </div>
  );
}
